module.exports = __webpack_public_path__ + "img/pencil.c257eb71.svg";